import { GLOBAL_SEARCH_DEEP_LINK_PARAMS } from "@/constants/global-search";
import { PATHS } from "@/constants/paths";

import { EProfileTab, ESettingsQueryParams, ESettingsSection } from "../types";

export interface IBuildModelsSettingsPathProps {
  // NOTE: NSAI-6598 — opens that model's details once the tab has loaded.
  modelUuid?: string | null;
}

// NOTE: NSAI-6657 — the one address of the project's Models screen now that it
// is a Profile settings tab. The model picker's link, the model notifications,
// global search and the `/models` redirect all build it here, so the tab id and
// the deep-link parameter cannot drift apart.
export const buildModelsSettingsPath = ({
  modelUuid,
}: IBuildModelsSettingsPathProps = {}): string => {
  const params = new URLSearchParams({
    [ESettingsQueryParams.SECTION]: ESettingsSection.PROFILE,
    [ESettingsQueryParams.TAB]: EProfileTab.MODELS,
  });

  if (modelUuid) {
    params.set(GLOBAL_SEARCH_DEEP_LINK_PARAMS.MODEL, modelUuid);
  }

  return `${PATHS.SETTINGS}?${params.toString()}`;
};
